import styles from './LanguageSwitcher.module.scss';

import { LANG_TO_LOCALE_MAP } from '@/utils';
import { storage } from '@/utils/storage';

import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  onClose: () => void;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  onClose,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const handleChangeLang = async (lang: string) => {
    await storage.setItem('lang', lang);
    i18n.changeLanguage(lang);
    onClose();
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent} ref={contentRef}>
        {Object.keys(LANG_TO_LOCALE_MAP).map((key) => (
          <div
            key={key}
            className={`${styles.languageItem} ${i18n.language === key ? styles.active : ''}`}
            onClick={() => handleChangeLang(key)}
          >
            {key}
          </div>
        ))}
      </div>
    </div>
  );
};
